import * as ActionTypes from "../Types/ActionTypes";

export const BranchUsers = (
  state = {
    isLoading: true,
    errMess: null,
    branchUsers: [],
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.FETCH_BRANCH_USERS:
      return {
        ...state,
        isLoading: false,
        errMess: null,
        branchUsers: action.payload,
      };

    case ActionTypes.BRANCH_USERS_LOADING:
      return {
        ...state,
        isLoading: true,
        errMess: null,
        branchUsers: [],
      };

    case ActionTypes.BRANCH_USERS_FAILED:
      return {
        ...state,
        isLoading: false,
        errMess: action.payload,
        branchUsers: [],
      };

    default:
      return state;
  }
};
